/**
 * 配置编译环境和线上环境之间的切换
 * baseUrl: 域名地址
 */
let adminApi = "";
let domainApi = '';
let domainUrl = '';
let mcyApi = '//m.cheyun.com/';
let mcyApi2 = '//m2.cheyun.com/';
let arkUrl = '//ark.cheyun.com/';
let cyLoginUrl = arkUrl + 'auth/login';
let cyDomain = '//www.cheyun.com/'; //老域名
let cySecureDomain = '//www.cheyun.com/'; //安全域名 暂时没有用到
let cySearchResultUrl = cyDomain+ 'search/';
let cyPostUrl = cyDomain + 'post'; //投稿
let cyAboutUrl = cyDomain + 'about/';
let cyAskNewsUrl = cyAboutUrl+ 'snews';
if (process.env.NODE_ENV === 'development') {
    cyDomain = "//localhost:8080/";
    domainUrl = '//localhost:8080/';
    //domainUrl = '//test.w.cheyun.com/'
    //domainApi = '//dev.api.cheyun.com/';
    domainApi = '//test.cyapi.cheyun.com/';
    // domainApi = '//openapi.cheyun.com/';
    adminApi = "//test.admin.cheyun.com/"
} else if (process.env.NODE_ENV === 'production'){
    domainUrl = '//www.cheyun.com/';
    domainApi = '//openapi.cheyun.com/';
    adminApi = "//report-api.cheyun.com/"
}
export {
    cyDomain,
    cySecureDomain,
    cyPostUrl,
    domainApi,
    domainUrl,
    cyLoginUrl,
    cySearchResultUrl,
    cyAboutUrl,
    mcyApi,
    mcyApi2,
    arkUrl,
    cyAskNewsUrl,
    adminApi
}


// WEBPACK FOOTER //
// ./src/config/env.js